import { FileCollectionItemT, ObjectContainerClientT } from 'bovaljaren-models';
import { isMountedReactApp } from '../../../../utils/app.helper';
import { ToggleValuesT } from './ObjectView';
import React from 'react';

export type CurrentImageT = { image: FileCollectionItemT; subtype: string;};

type ObjectViewPaperProps = {
    currentImage?: CurrentImageT;
    selectedObject?: ObjectContainerClientT;
    toggleShow: (value: ToggleValuesT) => void ;
    onClose: () => void;
    style?: {},
    showIframeOne: boolean;
};

export const ObjectViewWrapper: React.FC<{fullscreen: boolean; onClose?: () => void; }> = ({ children, fullscreen, onClose }) =>
    <div
        style={{
            position: !fullscreen && isMountedReactApp() ? 'fixed' : 'absolute'
        }}
        className={'bv-objectview'}
        onClick={(evt): void => {
            if (evt.target !== evt.currentTarget) return;

            onClose && onClose();

        }}
    >{children}</div>;

export const ObjectViewPaper: React.FC<ObjectViewPaperProps> = ({ children, currentImage, selectedObject, toggleShow, onClose, showIframeOne, style }) =>
    <div className={`bv-objectview-paper ${(currentImage?.subtype === 'floorplan' && !selectedObject?.imageCollectionId && !showIframeOne) ? 'bv-objectview-paper--floorplan' : ''}`}
        tabIndex={0}
        style={{
            height: window.innerWidth <= 1023 ? 'auto' : `calc(${isMountedReactApp() ? '50vw' : '100%'} - (4rem))`,
            ...style
        }}
        onKeyDown={(e: React.KeyboardEvent): void => {
            if (e.key.toLocaleLowerCase() === 'escape') {
                toggleShow('images');
                onClose && onClose();
            }
        }}>{children}</div>;


type ObjectViewSideProps = {
    currentImage?: CurrentImageT;
    selectedObject?: ObjectContainerClientT;
    showIframeOne: boolean;
}
export const ObjectViewLeft: React.FC<ObjectViewSideProps> = ({ children, currentImage, selectedObject, showIframeOne }) =>
    <div className={`bv-objectview-content-left ${(currentImage?.subtype === 'floorplan' && !selectedObject?.imageCollectionId && !showIframeOne) ? 'bv-objectview-content-left--floorplan' : ''}`}>{children}</div>;

export const ObjectViewLeftLower: React.FC<{title: string}> = ({ children, title }) =>
    <div className='bv-objectview-content-left-lower'>
        <div className='bv-objectview-title'>
            {title}
        </div>
        {children}
    </div>;

export const ObjectViewRight: React.FC<ObjectViewSideProps> = ({ children, currentImage, selectedObject, showIframeOne }) =>
    <div className={`bv-objectview-content-right objectview-main-content-full ${(currentImage?.subtype === 'floorplan' && !selectedObject?.imageCollectionId && !showIframeOne) ? 'bv-objectview-content-right--floorplan' : ''}`}>
        <div className='bv-objectview-content-right-aspect'>
            {children}
        </div>
    </div>;

export const ObjectViewContent: React.FC = ({ children }) => <div className={'bv-objectview-content'}>{children}</div>;
export const LeftSubColContent: React.FC = ({ children }) => <div className='bv-objectview-content-left-subcolumn'>{children}</div>;

export const LeftSubCol: React.FC = ({ children }) => <div className='bv-objectview-content-left-twocol'>{children}</div>;